import { useState, useEffect } from "react"
import isEmpty from "lodash/isEmpty"
import useFetch from "hooks/use-new-fetch"

export function usePlanData(initialPlans) {
  const [data, setData] = useState(initialPlans || {})

  const [billingDataRequest] = useFetch("/account/billing/plan_comparison")
  const [switchPlanRequest] = useFetch("/account/billing/switch_plan")

  useEffect(() => {
    async function fetchData() {
      if (isEmpty(initialPlans)) {
        const response = await billingDataRequest.get()
        setData(response.data)
      }
    }
    fetchData()
  }, [initialPlans, billingDataRequest])

  const switchPlan = async plan_id => {
    return await switchPlanRequest.put({
      data: { plan_id }
    })
  }

  return {
    plans: data.plans,
    trialing: data.trialing,
    currentPlan: data.current_plan,
    accountBillingState: data.account_billing_state,
    planLimits: data.plan_limits,
    switchPlan
  }
}
